
import { useState } from 'react';

export default function Videos() {
  const [selectedVideo, setSelectedVideo] = useState(0);

  const videos = [
    {
      id: 1,
      title: "短編映画「静寂の中で」",
      description: "心の奥底に眠る感情を描いた自主制作短編映画。繊細な演技と美しい映像美で贈る感動作品。",
      duration: "25分",
      price: 1500,
      thumbnail: "https://public.readdy.ai/ai/img_res/28705c2750f88be5f8a288eea687ba17.jpg",
      preview: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20Japanese%20independent%20film%20production%2C%20director%20and%20actor%20discussing%20scene%2C%20professional%20film%20equipment%2C%20creative%20atmosphere%2C%20warm%20lighting%2C%20artistic%20composition&width=800&height=450&seq=preview1&orientation=landscape"
    },
    {
      id: 2,
      title: "ドキュメンタリー「俳優への道」",
      description: "俳優としての歩みと挑戦を記録したドキュメンタリー。舞台裏の真実と成長の軌跡を赤裸々に描く。",
      duration: "40分",
      price: 2000,
      thumbnail: "https://readdy.ai/api/search-image?query=Documentary%20film%20poster%20about%20Japanese%20actor%20journey%2C%20professional%20headshot%20with%20film%20strips%20overlay%2C%20inspiring%20and%20motivational%20design%2C%20clean%20typography%2C%20warm%20color%20palette&width=400&height=600&seq=video2&orientation=portrait",
      preview: "https://readdy.ai/api/search-image?query=Documentary%20filming%20setup%20with%20Japanese%20actor%20being%20interviewed%2C%20professional%20camera%20equipment%2C%20studio%20lighting%2C%20authentic%20documentary%20atmosphere%2C%20candid%20moment&width=800&height=450&seq=preview2&orientation=landscape"
    },
    {
      id: 3,
      title: "舞台稽古密着「風の詩 制作記録」",
      description: "舞台「風の詩」の稽古から本番までを密着取材。演出家との議論、仲間との絆、舞台への情熱を記録。",
      duration: "35分",
      price: 1800,
      thumbnail: "https://readdy.ai/api/search-image?query=Theater%20rehearsal%20documentary%20poster%2C%20Japanese%20actors%20practicing%20on%20stage%2C%20dramatic%20stage%20lighting%2C%20behind%20the%20scenes%20atmosphere%2C%20professional%20theater%20production&width=400&height=600&seq=video3&orientation=portrait",
      preview: "https://readdy.ai/api/search-image?query=Theater%20rehearsal%20room%20with%20Japanese%20actors%20practicing%2C%20stage%20lights%2C%20scripts%20and%20props%20scattered%20around%2C%20collaborative%20creative%20environment%2C%20warm%20atmospheric%20lighting&width=800&height=450&seq=preview3&orientation=landscape"
    },
    {
      id: 4,
      title: "アクション特訓映像集",
      description: "特撮作品で培ったアクション技術の特訓風景。スタントマンとの練習やアクションシーンの裏側を公開。",
      duration: "30分",
      price: 1200,
      thumbnail: "https://readdy.ai/api/search-image?query=Action%20training%20documentary%20poster%2C%20Japanese%20actor%20performing%20martial%20arts%20and%20stunts%2C%20dynamic%20action%20poses%2C%20professional%20training%20facility%2C%20energetic%20and%20powerful%20composition&width=400&height=600&seq=video4&orientation=portrait",
      preview: "https://readdy.ai/api/search-image?query=Action%20training%20facility%20with%20Japanese%20actor%20practicing%20fight%20choreography%2C%20professional%20stunt%20equipment%2C%20dynamic%20movement%2C%20training%20atmosphere%2C%20dramatic%20lighting&width=800&height=450&seq=preview4&orientation=landscape"
    }
  ];

  const handlePurchase = async (videoId: number, price: number, title: string) => {
    try {
      const response = await fetch('/api/create-checkout-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          videoId,
          price,
          title
        }),
      });

      const { url } = await response.json();
      window.location.href = url;
    } catch (error) {
      alert('決済処理でエラーが発生しました。もう一度お試しください。');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900" style={{fontFamily: '"Pacifico", serif'}}>
                高原知秀
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap">
                  ホーム
                </a>
                <a href="/#about" className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap">
                  プロフィール
                </a>
                <a href="/#works" className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap">
                  ギャラリー
                </a>
                <a href="/videos" className="bg-gray-900 text-white px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap rounded-md">
                  動画コンテンツ
                </a>
                <a href="/#contact" className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium cursor-pointer whitespace-nowrap">
                  お問い合わせ
                </a>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* ヒーローセクション */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20film%20production%20studio%20with%20cameras%20and%20lighting%20equipment%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%2C%20modern%20video%20production%20setup%2C%20creative%20workspace%20for%20independent%20filmmaking&width=1200&height=400&seq=videohero&orientation=landscape')`
        }}
      >
        <div className="text-center text-white z-10 max-w-4xl mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            自主制作動画コンテンツ
          </h1>
          <p className="text-lg md:text-xl mb-8 max-w-2xl mx-auto leading-relaxed">
            俳優としての歩みと創作活動を記録した<br />
            プレミアム動画コンテンツをお楽しみください
          </p>
        </div>
      </section>

      {/* 動画一覧セクション */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">プレミアム動画コンテンツ</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              俳優としての成長過程、制作の裏側、特別な瞬間を収めた貴重な映像をご覧いただけます
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
            {videos.map((video, index) => (
              <div key={video.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-500">
                <div className="relative group">
                  <img 
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute top-4 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {video.duration}
                  </div>
                  <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <button
                      onClick={() => setSelectedVideo(index)}
                      className="w-full bg-white/90 text-gray-900 py-2 px-4 rounded-lg font-medium hover:bg-white transition-colors duration-200 whitespace-nowrap"
                    >
                      プレビューを見る
                    </button>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{video.title}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{video.description}</p>
                  
                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold text-gray-900">
                      ¥{video.price.toLocaleString()}
                    </div>
                    <button
                      onClick={() => handlePurchase(video.id, video.price, video.title)}
                      className="bg-gray-900 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors duration-200 whitespace-nowrap"
                    >
                      購入する
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* プレビューモーダル */}
      {selectedVideo !== null && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <button
                onClick={() => setSelectedVideo(0)}
                className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-black/50 text-white rounded-full hover:bg-black/70 transition-colors duration-200 z-10"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
              
              <img 
                src={videos[selectedVideo].preview}
                alt="プレビュー"
                className="w-full h-96 object-cover object-top"
              />
              
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <h3 className="text-2xl font-bold mb-2">{videos[selectedVideo].title}</h3>
                <p className="text-lg opacity-90">{videos[selectedVideo].duration}</p>
              </div>
            </div>
            
            <div className="p-8">
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                {videos[selectedVideo].description}
              </p>
              
              <div className="bg-gray-50 p-6 rounded-xl">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">このコンテンツに含まれるもの：</h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    高画質動画（1080p）
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    購入後即座に視聴可能
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    期限なしで何度でも視聴
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    特別なメイキング映像
                  </li>
                </ul>
              </div>
              
              <div className="flex items-center justify-between mt-8">
                <div className="text-3xl font-bold text-gray-900">
                  ¥{videos[selectedVideo].price.toLocaleString()}
                </div>
                <button
                  onClick={() => handlePurchase(videos[selectedVideo].id, videos[selectedVideo].price, videos[selectedVideo].title)}
                  className="bg-gray-900 text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-gray-800 transition-colors duration-200 whitespace-nowrap"
                >
                  今すぐ購入
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 特典セクション */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">購入者限定特典</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-gray-50 rounded-2xl">
              <div className="w-16 h-16 flex items-center justify-center bg-gray-900 rounded-full mx-auto mb-6">
                <i className="ri-video-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">高画質配信</h3>
              <p className="text-gray-600 leading-relaxed">
                1080p高画質で制作された映像を、ストリーミングでお楽しみいただけます
              </p>
            </div>
            
            <div className="text-center p-8 bg-gray-50 rounded-2xl">
              <div className="w-16 h-16 flex items-center justify-center bg-gray-900 rounded-full mx-auto mb-6">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">無制限視聴</h3>
              <p className="text-gray-600 leading-relaxed">
                一度購入いただければ、期限なしで何度でもご視聴いただけます
              </p>
            </div>
            
            <div className="text-center p-8 bg-gray-50 rounded-2xl">
              <div className="w-16 h-16 flex items-center justify-center bg-gray-900 rounded-full mx-auto mb-6">
                <i className="ri-star-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">特別映像</h3>
              <p className="text-gray-600 leading-relaxed">
                メイキング映像や未公開シーンなど、購入者だけの特別コンテンツ
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-4" style={{fontFamily: '"Pacifico", serif'}}>高原知秀</h3>
              <p className="text-gray-300 mb-4">
                映画、ドラマ、舞台で活躍するフリーランス俳優。<br />
                あらゆるキャラクターに命を吹き込みます。
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-300 hover:text-white">
                  <i className="ri-twitter-line text-2xl"></i>
                </a>
                <a href="#" className="text-gray-300 hover:text-white">
                  <i className="ri-instagram-line text-2xl"></i>
                </a>
                <a href="#" className="text-gray-300 hover:text-white">
                  <i className="ri-youtube-line text-2xl"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">ナビゲーション</h4>
              <ul className="space-y-2">
                <li><a href="/" className="text-gray-300 hover:text-white">ホーム</a></li>
                <li><a href="/#about" className="text-gray-300 hover:text-white">プロフィール</a></li>
                <li><a href="/#works" className="text-gray-300 hover:text-white">ギャラリー</a></li>
                <li><a href="/videos" className="text-gray-300 hover:text-white">動画コンテンツ</a></li>
                <li><a href="/#contact" className="text-gray-300 hover:text-white">お問い合わせ</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
              <div className="space-y-2 text-gray-300">
                <p><i className="ri-mail-line mr-2"></i>hide22031973@gmail.com</p>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2023 高原知秀 Actor Portfolio. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
